export enum ELoadingTypes {
  Ingredients = 'Ingredients',
  Layers = 'Layers',
  Images = 'Images',
  PlateImages = 'Plate Images',
  Design = 'Design',
  Loading = '...',
  Saving = 'Saving...',
  Global = 'Global-Data',
}
